import { EnumSchema, Executor, FromSchema, IdentityVerificationStatus, Omit, Replace } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { UserPermissions, UserPermissionsSchema } from './user.permissions';
import { BuyerRoles, SupplierRoles, UserRole } from './user.role.enum';
import { UsersStatus } from './users.status';
import { StripeIdentity, StripeIdentitySchema } from '@40seas/entities/stripe';

export const UserSchema = WithBaseEntitySchema(
    z.object({
        id: z.string().regex(/^[0-9a-f]{24}$/i),
        email: z.string().email(),
        name: z.string().nullish(),
        status: z.string(EnumSchema(UsersStatus)).optional(),
        auth0userId: z.string().optional(),
        slackId: z.string().optional(),
        picture: z.string().optional(),
        verifyIdentityStatus: z.string(EnumSchema(IdentityVerificationStatus)).optional(),
        verifyIdentityId: z.string().optional(),
        identity: StripeIdentitySchema.nullish(),
        roles: z.array(EnumSchema(UserRole)).optional(),
        permissions: UserPermissionsSchema.nullish(),
    }),
).strict();

export class User extends FromSchema(UserSchema) implements BaseEntity {
    id: string;
    email: string;
    name?: string;
    status?: UsersStatus;
    auth0userId?: string;
    slackId?: string;
    picture?: string;
    createdBy?: Executor;
    createdAt?: Date;
    updatedAt?: Date;
    roles?: UserRole[];
    verifyIdentityStatus?: IdentityVerificationStatus;
    verifyIdentityId?: string;
    identity?: StripeIdentity;
    permissions?: UserPermissions | null;
    seller?: string;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}

export class SupplierUser extends Replace(User, [
    {
        fieldName: 'roles',
        newFieldSchema: z.array(EnumSchema(SupplierRoles)),
    },
]) {}

export class BuyerUser extends Replace(User, [
    {
        fieldName: 'roles',
        newFieldSchema: z.array(EnumSchema(BuyerRoles)),
    },
]) {}

export class UserGroup extends Omit(User, ['tenantId']) {
    tenants: string[];
}
